import { Avatar } from "@mantine/core";
import styled from "styled-components";
import SidebarItem from "./SidebarItem";
import { useAuth } from "../../context/AuthContext";
import { Link } from "react-router";
import { IconCalendar, IconUsers } from "@tabler/icons-react";


interface SidebarProps {
  sidebarOpen: boolean;
  companyLogo?: string;
  onLogoutClick: () => void;
}

const Sidebar = ({ sidebarOpen, companyLogo, onLogoutClick }: SidebarProps) => {
const { company } = useAuth();

  return (
    <StyledNav $isOpen={sidebarOpen}>
      <LogoWrapper $isOpen={sidebarOpen}>
        <Link to="/dashboard" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            {sidebarOpen ? (
                <img height={45} style={{ objectFit: "contain", cursor: "pointer" }} src={"/assets/logo.png"} alt="Logo" />
            ) : (
                <img height={40} style={{ objectFit: "contain", cursor: "pointer" }} src={"/assets/kronifyLogo.png"} alt="Logo" />
            )}
        </Link>
    </LogoWrapper>

      <NavbarItemsWrapper $isOpen={sidebarOpen}>
        <SidebarItem
          iconSrc="/assets/dashboardIcon.png"
          navigateTo="/dashboard"
          title="Özet Rapor"
          sidebarOpen={sidebarOpen}
        />

        {company?.modules?.isCalendarAvailable && (
          <SidebarItem
            icon={<IconCalendar size={20} />}
            navigateTo="/calendar"
            title="Takvim"
            sidebarOpen={sidebarOpen}
          />
        )}

        <SidebarItem
          iconSrc="/assets/employeesIcon.png"
          navigateTo="/employees"
          title="Çalışanlar"
          sidebarOpen={sidebarOpen}
        />

        <SidebarItem
          iconSrc="/assets/terminalIcon.png"
          navigateTo="/tablets"
          title="Tabletler"
          sidebarOpen={sidebarOpen}
        />

        <SidebarItem
          iconSrc="/assets/usersIcon.png"
          navigateTo="/panel-users"
          title="Panel Kullanıcıları"
          sidebarOpen={sidebarOpen}
        />

        {company?.modules?.isApplicantAvailable && (
          <SidebarItem
            icon={<IconUsers size={20} />}
            navigateTo="/human-resources"
            title="İnsan Kaynakları"
            isCollapsible
            subItems={[{ title: "CV Havuzu", navigateTo: "cv-pool" }]}
            sidebarOpen={sidebarOpen}
          />
        )}

        <SidebarItem
          iconSrc="/assets/settingsIcon.png"
          navigateTo="/settings"
          title="Ayarlar"
          isCollapsible
          subItems={[
            { title: "Genel Ayarlar", navigateTo: "general" },
            { title: "Departman Ayarları", navigateTo: "department" },
            { title: "Yetenek Ayarları", navigateTo: "skill" },
            { title: "Rol Ayarları", navigateTo: "role" },
            { title: "Kontrat Ayarları", navigateTo: "contract" },
          ]}
          sidebarOpen={sidebarOpen}
        />
      </NavbarItemsWrapper>

    </StyledNav>
  );
};

export default Sidebar;

const StyledNav = styled.nav<{ $isOpen: boolean }>`
  width: ${(p) => (p.$isOpen ? "280px" : "64px")};
  min-width: ${(p) => (p.$isOpen ? "280px" : "64px")};
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #d9d9d9;
  height: 100vh;
  flex-shrink: 0;
  transition: width 0.3s ease, min-width 0.3s ease;
  overflow: hidden;
`;

const LogoWrapper = styled.div<{ $isOpen: boolean }>`
  padding: 0 20px;
  padding-top: ${(p) => (p.$isOpen ? "20px" : "10px")};
  display: flex;
  align-items: center;
  height: 90px;
  flex-shrink: 0;
  justify-content: center;
`;

const NavbarItemsWrapper = styled.div<{ $isOpen: boolean }>`
  padding: ${(p) => (p.$isOpen ? "24px 16px" : "24px 8px")};
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex-grow: 1;
  overflow-y: auto;
`;



